import { render, staticRenderFns } from "./OrderNoteModal.vue?vue&type=template&id=2218c172&scoped=true&"
import script from "./OrderNoteModal.vue?vue&type=script&lang=js&"
export * from "./OrderNoteModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderNoteModal.vue?vue&type=style&index=0&id=2218c172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2218c172",
  null
  
)

export default component.exports